/* Dorabella – "La mia taglia" + calcolatore taglia perfetta
 * Taglie regolari (M–3XL / IT 44–52) e Dorabella Più curvy (41–49 / IT 50–58).
 * La preferenza è salvata come taglia italiana (IT) così vale per tutte le linee.
 * Tabelle dalla guida taglie ufficiale Dorabella. Nessuna app esterna. */
(function () {
  'use strict';
  var KEY = 'dora_my_size_v2';
  var OLD_KEY = 'dora_my_size_v1';
  var ONLY = 'dora_my_size_only_v1';
  var SKIP = 'dora_my_size_skip_until';

  // Guida alle taglie Dorabella (cm): seno, vita, bacino/fianchi
  var TABLES = {
    reg: [
      { it: 44, name: 'M', b: 98, w: 87, h: 100 },
      { it: 46, name: 'L', b: 102, w: 91, h: 104 },
      { it: 48, name: 'XL', b: 106, w: 95, h: 108 },
      { it: 50, name: 'XXL', b: 110, w: 99, h: 112 },
      { it: 52, name: '3XL', b: 114, w: 103, h: 116 }
    ],
    cur: [
      { it: 50, name: '41', b: 106, w: 94, h: 118 },
      { it: 52, name: '43', b: 110, w: 98, h: 122 },
      { it: 54, name: '45', b: 114, w: 102, h: 126 },
      { it: 56, name: '47', b: 119, w: 106, h: 130 },
      { it: 58, name: '49', b: 124, w: 110, h: 134 }
    ]
  };
  var REG_LETTER = { XS: 40, S: 42, M: 44, L: 46, XL: 48, XXL: 50, '2XL': 50, XXXL: 52, '3XL': 52, '4XL': 54 };
  var CUR_LETTER = { S: 48, M: 50, L: 52, XL: 54, XXL: 56, '2XL': 56, XXXL: 58, '3XL': 58, '4XL': 60 };

  function store(k, v) { try { if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function labelFor(it, line) {
    var t = TABLES[line === 'cur' ? 'cur' : 'reg'];
    for (var i = 0; i < t.length; i++) if (t[i].it === it) return line === 'cur' ? t[i].name + ' · IT ' + it : t[i].name + ' · ' + it;
    return 'IT ' + it;
  }
  function getPref() {
    try {
      var p = JSON.parse(read(KEY));
      if (p && p.it) return p;
      var o = JSON.parse(read(OLD_KEY));
      if (o && (o.number || o.letter)) {
        var it = parseInt(o.number, 10) || REG_LETTER[o.letter];
        if (it) { p = { it: it, line: 'reg', label: labelFor(it, 'reg') }; setPref(p); return p; }
      }
    } catch (e) {}
    return null;
  }
  function setPref(p) { store(KEY, p ? JSON.stringify(p) : null); if (!p) store(OLD_KEY, null); }

  function isCurvyVendor() { return /PI[UÙ]|CURVY/i.test(String(window.doraVendor || '')); }

  // Converte un valore taglia ("L (43)", "41 (50 IT)", "XL/2XL", "M/41", "Taglia Unica") in taglie italiane
  function sizesOf(value, curvyContext) {
    var v = String(value || '').toUpperCase().trim();
    var out = { it: [], universal: false };
    if (/UNIC|^UN$/.test(v)) { out.universal = true; return out; }
    function add(n) { if (n && out.it.indexOf(n) < 0) out.it.push(n); }
    var itMarked = v.match(/(\d{2})\s*IT/g) || [];
    itMarked.forEach(function (m) { add(parseInt(m, 10)); });
    var clean = v.replace(/(\d{2})\s*IT/g, ' ');
    var codes = clean.match(/\b(4[13579]|5[135])\b/g) || [];
    codes.forEach(function (c) { add(50 + (parseInt(c, 10) - 41)); });
    (clean.match(/\b(3[89]|[4-6]\d)\b/g) || []).forEach(function (n) {
      var x = parseInt(n, 10);
      if (x % 2 === 0) add(x);
    });
    var curvy = codes.length > 0 || curvyContext;
    if (!codes.length || !itMarked.length) {
      (clean.match(/\b(XXXL|4XL|3XL|2XL|XXL|XL|XS|S|M|L)\b/g) || []).forEach(function (l) {
        if (codes.length) return; // la lettera sulla linea curvy coincide con il codice già letto
        add((curvy ? CUR_LETTER : REG_LETTER)[l]);
      });
    }
    return out;
  }
  function matches(value, pref, curvyContext) {
    if (!pref) return false;
    var s = sizesOf(value, curvyContext);
    return s.universal || s.it.indexOf(pref.it) > -1;
  }

  /* ---------- Calcolatore ---------- */
  // Stima delle misure da altezza e peso (media per corporatura femminile adulta); le misure reali, se inserite, hanno la precedenza.
  function estimate(height, weight, shape) {
    var bmi = weight / Math.pow(height / 100, 2);
    var dh = height - 165;
    var m = {
      b: 1.96 * bmi + 46.9 + dh * 0.15,
      w: 2.28 * bmi + 23.8 + dh * 0.1,
      h: 2.07 * bmi + 50.5 + dh * 0.2
    };
    if (shape === 'pear') { m.h += 5; m.b -= 2; }
    if (shape === 'apple') { m.w += 6; m.b += 2; }
    if (shape === 'top') { m.b += 5; m.h -= 2; }
    return m;
  }
  function pick(table, m, fit) {
    var slack = fit === 'slim' ? 2 : fit === 'loose' ? -3 : 0;
    for (var i = 0; i < table.length; i++) {
      var r = table[i];
      if (m.b <= r.b + slack && m.h <= r.h + slack && m.w <= r.w + slack + 3) return i;
    }
    return -1;
  }
  function recommend(input) {
    var m = estimate(input.height, input.weight, input.shape);
    var measured = false;
    if (input.bust) { m.b = input.bust; measured = true; }
    if (input.waist) { m.w = input.waist; measured = true; }
    if (input.hips) { m.h = input.hips; measured = true; }
    var ri = pick(TABLES.reg, m, input.fit);
    var ci = pick(TABLES.cur, m, input.fit);
    var res = { measured: measured, main: null, alt: null };
    if (ri > -1) {
      res.main = { line: 'reg', row: TABLES.reg[ri] };
      if (ci > -1 && ri >= 3) res.alt = { line: 'cur', row: TABLES.cur[ci] };
    } else if (ci > -1) {
      res.main = { line: 'cur', row: TABLES.cur[ci] };
    }
    return res;
  }

  /* ---------- Popup ---------- */
  var modal, draft = null, line = 'reg';
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function openModal(tab) {
    modal = modal || $('[data-dora-ms]');
    if (!modal) return;
    var p = getPref();
    draft = p ? { it: p.it, line: p.line || 'reg' } : null;
    line = draft ? draft.line : (isCurvyVendor() ? 'cur' : 'reg');
    showTab(tab || 'pick');
    syncModal();
    var res = $('[data-dora-calc-result]', modal); if (res) res.hidden = true;
    var form = $('[data-dora-calc-form]', modal); if (form) form.hidden = false;
    modal.hidden = false;
    document.body.classList.add('overflow-hidden');
  }
  function closeModal() {
    if (!modal) return;
    if (modal.getAttribute('data-auto') === '1' && !getPref()) snooze(3);
    modal.removeAttribute('data-auto');
    var later = $('[data-dora-ms-later]', modal); if (later) later.hidden = true;
    modal.hidden = true;
    document.body.classList.remove('overflow-hidden');
  }
  function showTab(name) {
    $$('[data-dora-ms-pane]', modal).forEach(function (p) { p.hidden = p.getAttribute('data-dora-ms-pane') !== name; });
    $$('.dora-ms__tab', modal).forEach(function (t) {
      var on = t.getAttribute('data-dora-ms-tab') === name;
      t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  }
  function syncModal() {
    $$('[data-dora-ms-line]', modal).forEach(function (b) {
      var on = b.getAttribute('data-dora-ms-line') === line;
      b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    $$('[data-dora-ms-sizes]', modal).forEach(function (g) { g.hidden = g.getAttribute('data-dora-ms-sizes') !== line; });
    $$('.dora-ms__opt', modal).forEach(function (b) {
      var on = !!draft && draft.line === b.getAttribute('data-line') && draft.it === parseInt(b.getAttribute('data-it'), 10);
      b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function saveSize(it, ln) {
    setPref({ it: it, line: ln, label: labelFor(it, ln) });
    store(ONLY, '1');
    applyAll(true);
  }

  function renderResult(res) {
    var box = $('[data-dora-calc-result]', modal);
    var form = $('[data-dora-calc-form]', modal);
    if (!res.main) {
      box.innerHTML = '<p class="dora-calc__big" style="font-size:24px">Ti aiutiamo noi a trovare la taglia giusta</p>' +
        '<p>Le misure indicate sono fuori dalle nostre tabelle: una consulente ti consiglia il capo ideale.</p>' +
        (window.doraWhatsapp ? '<a class="button button--primary dora-ms__save" target="_blank" rel="noopener" href="https://wa.me/' + window.doraWhatsapp + '?text=' + encodeURIComponent('Ciao! Mi aiutate a scegliere la taglia?') + '">Scrivici su WhatsApp</a>' : '') +
        '<button type="button" class="dora-ms__reset link" data-dora-calc-again>Ricalcola</button>';
    } else {
      var mn = res.main, lineName = mn.line === 'cur' ? 'Dorabella Più · Curvy' : 'Dorabella';
      var html = '<p class="dora-calc__kicker">La tua taglia perfetta</p>' +
        '<p class="dora-calc__big">' + mn.row.name + ' <span>IT ' + mn.row.it + '</span></p>' +
        '<p class="dora-calc__line">' + lineName + '</p>';
      if (res.alt) {
        html += '<p class="dora-calc__alt">Ami le vestibilità curvy? In <b>Dorabella Più</b> sei una <b>' + res.alt.row.name + ' (IT ' + res.alt.row.it + ')</b>. ' +
          '<button type="button" class="link" data-dora-calc-save="' + res.alt.row.it + '" data-line="cur">Scegli questa</button></p>';
      }
      html += '<button type="button" class="button button--primary dora-ms__save" data-dora-calc-save="' + mn.row.it + '" data-line="' + mn.line + '">Salva e mostra i miei capi</button>' +
        '<p class="dora-calc__note">' + (res.measured ? 'Calcolata sulle tue misure e sulla guida taglie Dorabella.' : 'Stima calcolata da altezza, peso e silhouette sulla guida taglie Dorabella. Per la massima precisione inserisci seno, vita e fianchi.') + ' Ogni capo ha una sua vestibilità: controlla sempre la scheda prodotto.</p>' +
        '<button type="button" class="dora-ms__reset link" data-dora-calc-again>Ricalcola</button>';
      box.innerHTML = html;
    }
    form.hidden = true;
    box.hidden = false;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-dora-calc-form]');
    if (!form) return;
    e.preventDefault();
    var f = form.elements;
    var num = function (n) { var x = parseFloat(String(f[n].value).replace(',', '.')); return isNaN(x) ? null : x; };
    var height = num('height'), weight = num('weight');
    var bust = num('bust'), waist = num('waist'), hips = num('hips');
    if ((!height || !weight) && !(bust && hips)) {
      (f.height.value ? f.weight : f.height).focus();
      form.querySelector('.dora-calc__row').classList.add('is-error');
      return;
    }
    renderResult(recommend({
      height: height || 165, weight: weight || 65,
      shape: (form.querySelector('input[name="shape"]:checked') || {}).value,
      fit: (form.querySelector('input[name="fit"]:checked') || {}).value,
      bust: bust, waist: waist, hips: hips
    }));
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    var opener = t.closest('[data-dora-open-mysize]');
    if (opener) { e.preventDefault(); closeSizeGuide(); openModal(opener.getAttribute('data-dora-open-mysize') === 'calc' ? 'calc' : 'pick'); return; }
    if (!modal || modal.hidden) return;
    if (t.closest('[data-dora-ms-close]')) { closeModal(); return; }
    var tab = t.closest('[data-dora-ms-tab]');
    if (tab) { showTab(tab.getAttribute('data-dora-ms-tab')); return; }
    var ln = t.closest('[data-dora-ms-line]');
    if (ln) { line = ln.getAttribute('data-dora-ms-line'); syncModal(); return; }
    var opt = t.closest('.dora-ms__opt');
    if (opt) {
      var it = parseInt(opt.getAttribute('data-it'), 10), l = opt.getAttribute('data-line');
      draft = draft && draft.it === it && draft.line === l ? null : { it: it, line: l };
      syncModal(); return;
    }
    if (t.closest('[data-dora-ms-save]')) {
      if (!draft) { setPref(null); store(ONLY, null); applyAll(); } else saveSize(draft.it, draft.line);
      closeModal(); return;
    }
    var cs = t.closest('[data-dora-calc-save]');
    if (cs) { saveSize(parseInt(cs.getAttribute('data-dora-calc-save'), 10), cs.getAttribute('data-line')); closeModal(); return; }
    if (t.closest('[data-dora-calc-again]')) {
      $('[data-dora-calc-result]', modal).hidden = true; $('[data-dora-calc-form]', modal).hidden = false; return;
    }
    if (t.closest('[data-dora-ms-reset]')) { store(ONLY, null); closeModal(); applyAll(); return; }
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-dora-ms-only-toggle]')) { store(ONLY, read(ONLY) ? null : '1'); applyAll(); }
  });
  document.addEventListener('keyup', function (e) { if (e.key === 'Escape') closeModal(); });

  function closeSizeGuide() {
    var open = document.querySelector('modal-dialog[open]');
    if (open && typeof open.hide === 'function') open.hide();
  }

  /* ---------- Card prodotto e collezioni ---------- */
  function applyCards(pref) {
    var only = !!(pref && read(ONLY));
    $$('.card-product-sizes-inline').forEach(function (wrap) {
      var hit = false, hitLabel = '';
      $$('.card-product-size-item', wrap).forEach(function (s) {
        var m = matches(s.textContent, pref, false);
        s.classList.toggle('is-mine', m);
        if (m) { if (!hit) hitLabel = s.textContent.trim(); hit = true; }
      });
      quickAddLabel(wrap, hit ? hitLabel : '');
      var inGrid = !!wrap.closest('#product-grid');
      var card = inGrid ? (wrap.closest('#product-grid > li') || wrap.closest('li')) : (wrap.closest('.card-wrapper') || wrap.closest('li'));
      if (card) {
        card.classList.toggle('dora-ms-miss', !!pref && !hit);
        card.classList.toggle('dora-ms-hidden', inGrid && only && !hit);
      }
    });
  }
  function emptyNotice(pref) {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    var cards = grid.querySelectorAll(':scope > li');
    var visible = Array.prototype.filter.call(cards, function (c) { return !c.classList.contains('dora-ms-hidden'); }).length;
    var box = $('[data-dora-ms-empty]');
    var show = !!(pref && read(ONLY) && cards.length && !visible);
    if (show && !box) {
      box = document.createElement('div');
      box.className = 'dora-ms-empty';
      box.setAttribute('data-dora-ms-empty', '');
      box.innerHTML = '<p>In questa pagina non ci sono capi disponibili nella tua taglia.</p>' +
        '<button type="button" class="button button--primary" data-dora-ms-only-toggle>Mostra tutti i capi</button>';
      grid.parentNode.insertBefore(box, grid);
    }
    if (box) box.hidden = !show;
  }
  function ensureBar(pref) {
    var grid = document.getElementById('product-grid');
    if (!grid || !$('.card-product-sizes-inline')) return;
    var bar = $('[data-dora-ms-bar]');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'dora-ms-bar';
      bar.setAttribute('data-dora-ms-bar', '');
      var slot = document.querySelector('#main-collection-filters .facets-container .flex.w-full > div');
      var drawerBtn = slot && slot.querySelector('.open-drawer-btn');
      if (slot) { slot.insertBefore(bar, drawerBtn || null); bar.classList.add('dora-ms-bar--inline'); }
      else grid.parentNode.insertBefore(bar, grid);
    }
    if (!pref) {
      bar.innerHTML = '<button type="button" class="dora-ms-bar__chip" data-dora-open-mysize><span class="dora-ms-bar__pre">La mia</span> taglia</button>';
    } else {
      var on = !!read(ONLY);
      bar.innerHTML =
        '<button type="button" class="dora-ms-bar__chip' + (on ? ' is-active' : '') + '" data-dora-ms-only-toggle aria-pressed="' + on + '">' +
        '<span class="dora-ms-bar__pre">Solo</span>' + pref.label + '</button>' +
        '<button type="button" class="link dora-ms-bar__change" data-dora-open-mysize aria-label="Cambia taglia"><span>Cambia</span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 20h4l10-10-4-4L4 16v4zM13 7l4 4"/></svg></button>';
    }
  }

  /* ---------- Scheda prodotto ---------- */
  function applyPdp(pref, userAction) {
    var note = $('[data-dora-my-size-pdp]');
    if (!note) return;
    var fieldset = note.closest('fieldset') || note.parentElement.closest('.product-form__input');
    if (!pref) {
      note.hidden = false;
      note.innerHTML = '<button type="button" class="link" data-dora-open-mysize="calc">Calcola la tua taglia perfetta</button> e la selezioniamo noi ogni volta.';
      return;
    }
    var curvy = isCurvyVendor();
    var inputs = fieldset ? fieldset.querySelectorAll('input[type="radio"]') : [];
    var mine = Array.prototype.filter.call(inputs, function (i) { return matches(i.value, pref, curvy); });
    Array.prototype.forEach.call(inputs, function (i) {
      var l = fieldset.querySelector('label[for="' + i.id + '"]');
      if (l) l.classList.toggle('is-mine', mine.indexOf(i) > -1);
    });
    note.hidden = false;
    if (!mine.length) {
      note.innerHTML = 'Questo capo non ha la tua taglia (' + pref.label + '). <button type="button" class="link" data-dora-open-mysize>Cambia</button>';
      return;
    }
    var available = mine.filter(function (i) { return !i.classList.contains('disabled'); });
    if (!available.length) {
      note.innerHTML = '<strong>La tua taglia (' + pref.label + ') è esaurita</strong> su questo capo.';
      return;
    }
    note.innerHTML = 'La tua taglia: <strong>' + pref.label + '</strong> · <button type="button" class="link" data-dora-open-mysize>Cambia</button>';
    var hasVariantParam = /[?&]variant=/.test(location.search);
    if ((userAction || !hasVariantParam) && !available[0].checked) available[0].click();
  }

  var busy = false;
  function applyAll(userAction) {
    if (busy) return;
    busy = true;
    var pref = getPref();
    try {
      applyCards(pref);
      ensureBar(pref);
      emptyNotice(pref);
      applyPdp(pref, userAction === true);
    } finally { busy = false; }
  }

  /* ---------- Aggiunta diretta al carrello dalla card (con taglia salvata) ---------- */
  function cardOf(el) { return el.closest('#product-grid > li') || el.closest('.card-wrapper') || el.closest('li'); }
  function quickAddLabel(wrap, sizeText) {
    var card = cardOf(wrap); if (!card) return;
    var qv = card.querySelector('quick-view[data-product-handle]'); if (!qv) return;
    var lab = qv.querySelector('.dora-qa');
    if (sizeText) {
      if (!lab) { lab = document.createElement('span'); lab.className = 'dora-qa'; qv.insertBefore(lab, qv.firstChild); }
      // taglia unica o etichette lunghe: il pulsante resta corto (la taglia e' gia' scritta sotto la card)
      var shortSize = /unica/i.test(sizeText) ? '' : sizeText.replace(/\s*\(.*\)\s*/g, '').trim();
      lab.textContent = shortSize ? 'Aggiungi ' + shortSize : 'Aggiungi';
      qv.classList.add('dora-qa-direct');
      qv.setAttribute('aria-label', 'Aggiungi al carrello taglia ' + sizeText);
    } else if (lab) {
      lab.remove(); qv.classList.remove('dora-qa-direct'); qv.setAttribute('aria-label', 'Scegli la taglia');
    }
  }
  function pickVariant(product, pref) {
    var idx = -1;
    product.options.forEach(function (o, i) { if (idx < 0 && /tagl|size|misur|dimens/i.test(o.name || o)) idx = i; });
    if (idx < 0) return null;
    var curvy = /PI[UÙ]|CURVY/i.test(product.vendor || '');
    var mine = product.variants.filter(function (v) { return v.available && matches(v.options[idx], pref, curvy); });
    if (!mine.length) return null;
    var first = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
    var same = mine.filter(function (v) { return v.options.every(function (val, i) { return i === idx || val === first.options[i]; }); });
    return (same[0] || mine[0]);
  }
  function toast(msg) {
    var t = document.createElement('div'); t.className = 'dora-toast'; t.setAttribute('role', 'status'); t.textContent = msg;
    document.body.appendChild(t); setTimeout(function () { t.classList.add('is-in'); }, 10);
    setTimeout(function () { t.classList.remove('is-in'); setTimeout(function () { t.remove(); }, 300); }, 2600);
  }
  document.addEventListener('click', function (e) {
    var qv = e.target.closest && e.target.closest('quick-view.dora-qa-direct[data-product-handle]');
    if (!qv) return;
    var pref = getPref(); if (!pref) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    if (qv.classList.contains('is-loading')) return;
    qv.classList.add('is-loading');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var drawer = document.querySelector('cart-drawer');
    fetch(root + 'products/' + qv.getAttribute('data-product-handle') + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var v = pickVariant(product, pref);
        if (!v) { qv.classList.remove('dora-qa-direct'); qv.classList.remove('is-loading'); qv.click(); return null; }
        var body = { items: [{ id: v.id, quantity: 1 }] };
        if (drawer && drawer.getSectionsToRender) { body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = location.pathname; }
        return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            qv.classList.remove('is-loading');
            if (res.status) { toast(res.description || 'Taglia non disponibile'); return; }
            if (drawer && drawer.renderContents && res.sections) {
              drawer.classList.remove('is-empty');
              drawer.renderContents(res);
            } else {
              toast('Aggiunto al carrello ✓');
            }
          });
      })
      .catch(function () { qv.classList.remove('is-loading'); toast('Non siamo riusciti ad aggiungere il capo, riprova'); });
  }, true);

  /* ---------- Richiesta automatica della taglia (home e scheda prodotto) ---------- */
  function snooze(days) { store(SKIP, String(Date.now() + days * 864e5)); }
  function snoozed() { var u = parseInt(read(SKIP), 10); return u && Date.now() < u; }
  function autoPrompt() {
    var tpl = String(window.doraTemplate || '');
    if (!/^(index|product)/.test(tpl) || getPref() || snoozed()) return;
    var ss = null; try { ss = sessionStorage.getItem('dora_ms_prompted'); } catch (e) {}
    if (ss) return;
    setTimeout(function () {
      if (getPref() || document.querySelector('.dora-ms:not([hidden])')) return;
      var bodyLocked = getComputedStyle(document.body).overflow === 'hidden' || getComputedStyle(document.documentElement).overflow === 'hidden';
      if (document.querySelector('modal-dialog[open]') || bodyLocked) return;
      try { sessionStorage.setItem('dora_ms_prompted', '1'); } catch (e) {}
      openModal('pick');
      if (!modal) return;
      modal.setAttribute('data-auto', '1');
      var later = $('[data-dora-ms-later]', modal); if (later) later.hidden = false;
      var title = $('#dora-ms-title', modal); if (title) title.textContent = tpl.indexOf('product') === 0 ? 'Che taglia porti? Te la selezioniamo noi' : 'Che taglia porti?';
    }, tpl.indexOf('product') === 0 ? 2500 : 3500);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-dora-ms-later]')) { snooze(7); if (modal) modal.removeAttribute('data-auto'); closeModal(); }
  });

  function init() {
    applyAll();
    autoPrompt();
    var pending;
    new MutationObserver(function (muts) {
      if (busy) return;
      var relevant = muts.some(function (m) {
        return Array.prototype.some.call(m.addedNodes, function (n) {
          return n.nodeType === 1 && (n.matches('.card-product-sizes-inline, li, .card-wrapper, variant-selects, fieldset') || n.querySelector && n.querySelector('.card-product-sizes-inline, [data-dora-my-size-pdp]'));
        });
      });
      if (!relevant) return;
      clearTimeout(pending);
      pending = setTimeout(applyAll, 60);
    }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
  }

  window.DoraMySize = { sizesOf: sizesOf, matches: matches, recommend: recommend, estimate: estimate, open: openModal, get: getPref, tables: TABLES };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
